import React from "react";

const RefundPolicy = () => {
  return (
    <div className="md:mx-10 mx-6 xl:mx-0">
      <div className="max-w-7xl min-h-screen mx-auto  p-4 md:p-8 lg:p-8  mt-24 border bg-white shadow-lg rounded-lg my-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">
          Refund Policy
        </h1>
        <p className="text-gray-600 mb-4">
          At{" "}
          <span className="font-semibold">
            Dapplogix Software Private Limited
          </span>
          , we strive to provide the best possible service to our clients. This
          Refund Policy outlines the terms and conditions under which refunds
          may be provided for payments made through Razorpay.
        </p>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">
            1. General Terms
          </h2>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>
              All transactions made on our platform are subject to this refund
              policy.
            </li>
            <li>
              By making a payment through Razorpay, you agree to the terms set
              forth in this policy.
            </li>
            <li>
              Refunds are provided at the sole discretion of{" "}
              <span className="font-semibold">
                Dapplogix Software Private Limited
              </span>{" "}
              and are subject to approval based on the specific circumstances of
              the request.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">
            2. Eligibility for Refunds
          </h2>
          <p className="text-gray-600 mb-2">
            Refunds may be considered under the following conditions:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>Duplicate payment was made due to a technical error.</li>
            <li>
              Payment was made, but the service was not delivered as promised or
              expected.
            </li>
            <li>
              The service/product delivered was materially different from what
              was agreed upon.
            </li>
            <li>
              Cancellations made within a stipulated period as per the service
              terms (if applicable).
            </li>
          </ul>
          <p className="text-gray-600 mt-2 italic">
            <span className="font-semibold">Note :</span> Refunds will not be
            processed for dissatisfaction due to customer negligence or misuse
            of the service .
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">
            3. Refund Request Process
          </h2>
          <p className="text-gray-600 mb-2">
            To request a refund, the customer must:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>
              Email us at{" "}
              <a
                href="mailto:support@hirestar.io"
                className="text-blue-600 hover:underline"
              >
                support@hirestar.io
              </a>{" "}
              with the subject line “Refund Request – [Transaction ID]”
            </li>
            <li>Include the following details in the email:</li>
            <ul className="pl-6 space-y-2" style={{ listStyleType: "circle" }}>
              <li>Full Name</li>
              <li>Registered Email ID</li>
              <li>Transaction ID</li>
              <li>Reason for Refund Request</li>
              <li>Supporting Documents (if any)</li>
            </ul>
            <li>
              All refund requests must be submitted within{" "}
              <span className="font-semibold">7 days</span> of the transaction
              date.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-700 mb-3">
            4. Processing Time
          </h2>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>
              Approved refund requests will be processed within{" "}
              <span className="font-semibold"> 7–10 business days.</span>
            </li>
            <li>
              The amount will be refunded to the original payment method used at
              the time of purchase.
            </li>
            <li>
              The timeline for the refund to reflect in the user’s account is
              subject to Razorpay and the issuing bank’s policies.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-700 mb-3">
            5. Non-Refundable Transactions
          </h2>
          <p className="text-gray-600 mb-2">
            The following are generally non-refundable:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>Services that have already been availed/consumed.</li>
            <li>
              Custom work or products delivered as per client specifications.
            </li>
            <li>
              Any charges levied by payment gateways (unless otherwise agreed
              upon).
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-700 mb-3">
            6. Disputes & Chargebacks
          </h2>
          <p className="text-gray-600">
            If a chargeback or payment dispute is raised through your
            card-issuing bank or Razorpay, we reserve the right to investigate
            and contest such claims. False or fraudulent claims may lead to a
            suspension of service and potential legal action.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-700 mb-3">
            7. Policy Updates
          </h2>
          <p className="text-gray-600">
            <span className="font-semibold">
              Dapplogix Software Private Limited
            </span>{" "}
            reserves the right to modify this Refund Policy at any time without
            prior notice. All changes will be posted on this page with an
            updated effective date.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-700 mb-3">
            Contact Us
          </h2>
          <p className="text-gray-600">
            For any questions related to refunds, please contact us at:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>
              <span className="font-semibold">Email: </span>
              <a
                href="mailto:support@hirestar.io"
                className="text-blue-600 hover:underline"
              >
                support@hirestar.io
              </a>
            </li>
            <li>
              <span className="font-semibold">Phone: </span>
              <a
                href="tel:+919144101103"
                className="text-blue-600 hover:underline"
              >
                +91 9144101103
              </a>
            </li>
            <li>
              <span className="font-semibold">Address: </span> Thub, 20, Inorbit
              Mall Rd, Vittal Rao Nagar, Madhapur, Hyderabad, Telangana 500081
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default RefundPolicy;
